import { createSelector } from 'reselect';
import { getUserEntities } from '../entities';
import { getCurrentUser } from '../session';

export const getUserToEdit = createSelector(
  [getCurrentUser, getUserEntities],
  (currentUser, users) => {
    return users[currentUser.id];
  },
);
